// Utils
import { LinkCreationService } from '@sportal365/smp-widget-utils';

// Constants
import { ACTIVE } from '../../../../../packages/constants/actitivityStatus';
import { TARGET_BLANK, TARGET_SELF } from '../../../../../packages/constants/windowTarget';
import { assetsPlaceholder } from '../../../../../packages/constants/assetsPlaceholder';

// Types
import { IConfigEntityLinks, ISeason, ISeasonsDetailsStages } from '../../../../../packages/types';

interface INormalizeTournamentStageProps {
  season?: ISeason;
  stages?: ISeasonsDetailsStages[];
  stageId?: string;
  dataEntityLinks?: IConfigEntityLinks | null;
}

const getActiveStage = (stages?: ISeasonsDetailsStages[]) => {
  const activeStage = stages && stages.find(({ stage }) => stage.status === ACTIVE)?.stage;
  const defaultStage =
    stages && stages?.filter(({ rounds }) => rounds.length > 0).length
      ? stages?.filter(({ rounds }) => rounds.length > 0)[0].stage
      : undefined;

  if (activeStage) {
    return activeStage;
  }

  return defaultStage;
};

const getActiveRound = (stages?: ISeasonsDetailsStages[], stageId?: string) => {
  const selectedStageRound = stages?.find(({ stage }) => stage.id === stageId)?.rounds?.find(({ status }) => status === ACTIVE)?.id;
  const activeStageRound = stages?.find(({ stage }) => stage.status === ACTIVE)?.rounds?.find(({ status }) => status === ACTIVE)?.id;
  const defaultStageRound = stages?.filter(({ rounds }) => rounds.length > 0)[0]?.rounds?.find((round) => round.status === ACTIVE)?.id;

  if (stageId && activeStageRound) {
    return selectedStageRound;
  }

  if (!stageId && activeStageRound) {
    return activeStageRound;
  }

  return defaultStageRound;
};

export const normalizeTournamentStages = ({ season, stages, stageId, dataEntityLinks }: INormalizeTournamentStageProps) => {
  const linkService = dataEntityLinks && new LinkCreationService(dataEntityLinks);
  const target = dataEntityLinks?.configuration?.newWindow ? TARGET_BLANK : TARGET_SELF;

  const standingsUrl =
    (season?.tournament && linkService?.createEntityUrl(season?.tournament?.id || '', 'standings', '', season?.tournament?.slug || '')) ||
    '#';

  const competitionUrl =
    (season?.tournament &&
      linkService?.createEntityUrl(
        season?.tournament?.id || '',
        season?.tournament?.entityType || 'competition',
        '',
        season?.tournament?.slug || '',
      )) ||
    '#';

  return {
    tournament: {
      id: season?.tournament?.id,
      title: season?.tournament?.name,
      subTitle: season?.tournament?.country.name,
      tournamentUrl: competitionUrl,
      logo: season?.tournament?.assets?.logo?.url ?? assetsPlaceholder.tournament,
      standingsUrl: standingsUrl,
      target: target,
    },
    activeStage: getActiveStage(stages),
    activeRound: getActiveRound(stages, stageId),
    rounds:
      stages?.map(({ stage, rounds }) => ({
        stage: stage,
        rounds: rounds?.map(({ name, id }) => ({
          label: name,
          value: id,
        })),
      })) ?? [],
  };
};
